import moment from 'moment-timezone';
import { TIME_ZONE } from '@silvergatedelivery/constants';

const TIME_OPTIONS_LUNCH = [
  '10:00-11:00',
  '11:00-12:00',
  '12:00-13:00',
  '13:00-14:00',
];

const TIME_OPTIONS_DINNER = [
  '16:00-17:00',
  '17:00-18:00',
  '18:00-19:00',
];

const dayMapping = [
  'sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday',
];

const restaurantClosedOnDate = (dateToCheck, openingHours=[], holidaysSetting=[]) => {
  const dateItem = moment(dateToCheck).tz(TIME_ZONE);
  const date = dateItem.format('YYYY-MM-DD');
  const day = dateItem.day();

  if (holidaysSetting && holidaysSetting.length !== 0) {
    const year = dateItem.year();
    const holidays = holidaysSetting.find(
      (restaurantHoliday) => restaurantHoliday.year === year,
    );
    if (holidays && holidays.closedDays.length !== 0) {
      if (holidays.closedDays.includes(date)) {
        return true;
      }
    }
  }
  if (openingHours) {
    if (Object.keys(openingHours).every((key) => openingHours[key].length === 0)) {
      return false;
    }
    if (openingHours[dayMapping[day]].length === 0) {
      return true;
    }
  }
  return false;
};

const timeInSlot = (startTime, endTime, toCheck) => {
  const toMinutes = (time) => {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
  };
  return toMinutes(toCheck) >= toMinutes(startTime) && toMinutes(toCheck) <= toMinutes(endTime);
};

const getTimeSlotOptions = (openingHours=[], date, defaultTimeSlotOptions) => {
  let filteredOptions = defaultTimeSlotOptions;
  if (!openingHours ||
    Object.keys(openingHours).every((key) => openingHours[key].length === 0)) {
    return filteredOptions;
  }
  const day = moment(date).tz(TIME_ZONE).day();

  if (openingHours[dayMapping[day]].length === 0) {
    return [];
  } else {
    filteredOptions = defaultTimeSlotOptions.filter((option) => {
      const [slotStart, slotEnd] = option.split('-');
      if (openingHours[dayMapping[day]].some((openingHours)=> {
        if (timeInSlot(openingHours.startTime, openingHours.endTime, slotStart) ||
          timeInSlot(openingHours.startTime, openingHours.endTime, slotEnd)) {
          return true;
        }
        return false;
      })) {
        return true;
      }
      return false;
    });
  }

  return filteredOptions;
};

export function checkRestaurantClosed(dateTime, openingHours, holidays) {
  const restaurantClosedOnDateSelected = restaurantClosedOnDate(dateTime.date, openingHours, holidays);
  const lunchTimeSlotOptions = getTimeSlotOptions(openingHours, dateTime.date, TIME_OPTIONS_LUNCH);
  const dinnerTimeSlotOptions = getTimeSlotOptions(openingHours, dateTime.date, TIME_OPTIONS_DINNER);
  const restaurantClosedAtTimeSlotSelected = !lunchTimeSlotOptions.includes(dateTime.time) && !dinnerTimeSlotOptions.includes(dateTime.time);
  return restaurantClosedOnDateSelected || restaurantClosedAtTimeSlotSelected;
}
